export const MEETING_NOTETAKER_ALERT_DISMISSED = 'meeting-notetaker-alert-dismissed';